export default __webpack_public_path__ + "static/media/parallel-heiko.523444b3.svg";